import React, { useState } from 'react'
import * as Icons from 'react-feather'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts'
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'
import ExpenseRegisterModel from './models/ExpenseRegisterModel'
import ExpenseRegisterModal from './ExpenseRegisterModal'
import { getStorageValues } from '../../shared/CommonFunctions'
import { logAuditEvent } from '../../utils/auditLogger'
import { deleteExpenseRegister, fetchExpenseRegisterById, saveExpenseRegister } from '../../utils/expenseRegisterApi'

function ExpenseRegisterGrid(props) {
  const [actionType, setActionType] = useState()
  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [expenseRegisterModel, setExpenseRegisterModel] = useState(new ExpenseRegisterModel())
  const [filterText, setFilterText] = React.useState('')
  const [alert, setAlert] = useState(null)
  const moduleName = props.moduleName || 'Expense Register'

  function closeModal() {
    setIsOpen(false)
    props.fetchExpenseRegisters()
  }

  const rows = props.ExpenseRegisterData
    ? props.ExpenseRegisterData.filter((item) =>
      (item.ExpenseCategoryName && item.ExpenseCategoryName.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.ReferenceNo && item.ReferenceNo.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.ExpenseFor && item.ExpenseFor.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.Description && item.Description.toLowerCase().includes(filterText.toLowerCase()))
    )
    : []

  const openActionType = async (row, name) => {
    logAuditEvent(moduleName, 'View/Edit/Delete Button Click', JSON.stringify({
      Id: row?.ExpenseRegisterId,
      Name: row?.ExpenseCategoryName,
      Action: name
    }))

    if (name === 'Delete') {
      setExpenseRegisterModel(row)
      setIsOpen(true)
      setActionType(name)
      return
    }

    try {
      const record = await fetchExpenseRegisterById({ expenseRegisterId: row.ExpenseRegisterId })
      setExpenseRegisterModel(record || row)
      setIsOpen(true)
      setActionType(name)
    } catch (error) {
      console.log(error)
      CreateAlert('Unable to load expense register details', 'Error', setAlert)
    }
  }

  async function onSubmit(e, data) {
    const expenseRegisterData = data
    if (e.target.name === 'Edit') {
      let expenseRegisterDetails = {
        ExpenseRegisterId: expenseRegisterData.ExpenseRegisterId,
        ExpenseCategoryId: expenseRegisterData.ExpenseCategoryId || null,
        ExpenseDate: expenseRegisterData.ExpenseDate || null,
        Amount: expenseRegisterData.Amount || null,
        ReferenceNo: expenseRegisterData.ReferenceNo || '',
        ExpenseFor: expenseRegisterData.ExpenseFor || '',
        Description: expenseRegisterData.Description || '',
        UserId: getStorageValues('userId')
      }
      if (validation(expenseRegisterDetails)) {
        try {
          const response = await saveExpenseRegister(expenseRegisterDetails)
          if (response?.success) {
            if (response?.data?.success === 1 || response?.data?.success === undefined) {
              CreateAlert(response?.data?.message || 'Expense register updated successfully!!', 'Success', setAlert)
              props.fetchExpenseRegisters()
              closeModal()
            } else {
              CreateAlert(response?.data?.message || 'Unable to save record', 'Warning', setAlert)
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
    } else if (e.target.name === 'Delete') {
      let expenseRegisterDetails = {
        ExpenseRegisterId: expenseRegisterModel.ExpenseRegisterId,
        UserId: getStorageValues('userId')
      }
      try {
        const response = await deleteExpenseRegister(expenseRegisterDetails)
        if (response?.success) {
          CreateAlert('Expense register deleted successfully!!', 'Success', setAlert)
          props.fetchExpenseRegisters()
          closeModal()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  function validation(expenseRegisterDetails) {
    let isValid = true
    if (expenseRegisterDetails) {
      if (!expenseRegisterDetails.ExpenseCategoryId) {
        CreateAlert('Please select expense category!!', 'Warning', setAlert)
        return false
      }
      if (!expenseRegisterDetails.ExpenseDate) {
        CreateAlert('Please select expense date!!', 'Warning', setAlert)
        return false
      }
      const amountValue = Number(expenseRegisterDetails.Amount)
      if (!expenseRegisterDetails.Amount || Number.isNaN(amountValue) || amountValue <= 0) {
        CreateAlert('Please enter valid amount!!', 'Warning', setAlert)
        return false
      }
      if ((expenseRegisterDetails.Description || '').length > 600) {
        CreateAlert('Description can be maximum 600 characters!!', 'Warning', setAlert)
        return false
      }
    } else {
      CreateAlert('Some problem fetching details entered by the user!!', 'Error', setAlert)
      return (isValid = false)
    }
    return isValid
  }

  const columns = [
    {
      name: <div className="titlename"><span>Expense Category</span></div>,
      selector: row => row.ExpenseCategoryName,
      cell: (row) => (
        <span title={row.ExpenseCategoryName}>{row.ExpenseCategoryName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Date</span></div>,
      selector: row => row.ExpenseDate,
      cell: (row) => (
        <span title={row.ExpenseDate}>{row.ExpenseDate ? row.ExpenseDate.split('T')[0] : ''}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Amount</span></div>,
      selector: row => row.Amount,
      cell: (row) => (
        <span title={row.Amount}>{row.Amount}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Reference</span></div>,
      selector: row => row.ReferenceNo,
      cell: (row) => (
        <span title={row.ReferenceNo}>{row.ReferenceNo}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Expense For</span></div>,
      selector: row => row.ExpenseFor,
      cell: (row) => (
        <span title={row.ExpenseFor}>{row.ExpenseFor}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    }
  ]

  if (props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1) {
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
            props.UserPermissions.ViewModule === 1
              ? (
                <Link
                  className="me-2 p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, 'View')
                  }}
                >
                  <Icons.Eye data-feather="eye" className="action-eye" />
                </Link>
                )
              : null
          }
          {
            props.UserPermissions.EditModule === 1
              ? (
                <Link
                  className="me-2 p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, 'Edit')
                  }}
                >
                  <Icons.Edit data-feather="edit" className="feather-edit" />
                </Link>
                )
              : null
          }
          {
            props.UserPermissions.DeleteModule === 1
              ? (
                <Link
                  className="confirm-text p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, 'Delete')
                  }}
                >
                  <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
                </Link>
                )
              : null
          }
        </div>
      ),
      center: 'true',
      width: '150px'
    })
  }

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="ExpenseDate"
            sortIcon={<SortArrow />}
            persistTableHead={true}
          />
        </div>
      </div>
      <ExpenseRegisterModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={expenseRegisterModel}
        onSubmit={onSubmit}
        moduleName={moduleName}
      />
    </>
  )
}

export default ExpenseRegisterGrid
